import React, { useRef, useState, useEffect, forwardRef } from "react";
import "../css/FamilyTree.css";
import defaultPic from "../assets/default-profile.jpg";

// ✅ Add this here first
const ProfileCard = ({ member }) => (
  <div className="profile-card">
    <img src={defaultPic} alt="profile" className="profile-pic" />
    <h5>
      {member.gender === "male" ? "👨" : "👩"} {member.name}
    </h5>
    <p className="occupation">🛠️ {member.occupation || "N/A"}</p>
  </div>
);

const SpousePair = forwardRef(({ member }, ref) => (
  <div className="spouse-pair" ref={ref}>
    <ProfileCard member={member} />
    {member.spouse && (
      <>
        <div className="heart">💞</div>
        <ProfileCard member={member.spouse} />
      </>
    )}
  </div>
));

// ✅ Then keep your FamilyTreeStyled component below
const FamilyTreeStyled = ({ root }) => {
  const parentRef = useRef(null);
  const childRefs = useRef([]);
  const [lines, setLines] = useState([]);

  useEffect(() => {
    if (!parentRef.current || childRefs.current.length === 0) return;

    const parentBox = parentRef.current.getBoundingClientRect();
    const childBoxes = childRefs.current.map((ref) =>
      ref?.getBoundingClientRect()
    );

    const svgBox = document
      .querySelector(".tree-wrapper")
      .getBoundingClientRect();

    const newLines = childBoxes.map((childBox) => ({
      x1: parentBox.left + parentBox.width / 2 - svgBox.left,
      y1: parentBox.bottom - svgBox.top,
      x2: childBox.left + childBox.width / 2 - svgBox.left,
      y2: childBox.top - svgBox.top,
    }));

    setLines(newLines);
  }, [root]);

  return (
    <div className="generation">
      <div className="tree-wrapper">
        {/* SVG Connector Lines */}
        <svg className="connector-svg">
          {lines.map((line, i) => (
            <line
              key={i}
              x1={line.x1}
              y1={line.y1}
              x2={line.x2}
              y2={line.y2}
              stroke="#aaa"
              strokeWidth="2"
            />
          ))}
        </svg>

        {/* Generation 1 */}
        <div className="generation-row">
          <SpousePair member={root} ref={parentRef} />
        </div>

        {/* Generation 2 */}
        <div className="generation-row">
          {root.children.map((child, index) => (
            <div key={child.profileId} className="child-pair">
              <SpousePair
                member={child}
                ref={(el) => (childRefs.current[index] = el)}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Optional Generation 3 */}
      <div className="generation-row">
        {root.children.map(
          (child) =>
            child.children?.length > 0 && (
              <React.Fragment key={child.profileId}>
                {child.children.map((gChild) => (
                  <SpousePair key={gChild.profileId} member={gChild} />
                ))}
              </React.Fragment>
            )
        )}
      </div>
    </div>
  );
};

export default FamilyTreeStyled;
